import React from 'react';
import { RouteComponentProps, Switch, Route, Redirect } from 'react-router-dom';

import { RoomTypeListPage, AddRoomTypePage, EditRoomTypePage } from './pages';

export const RoomTypeRoutes: React.FC<RouteComponentProps> = ({ match }) => (
  <Switch>
    <Route path={match.path} exact component={RoomTypeListPage} />
    <Route path={`${match.path}/add`} component={AddRoomTypePage} />
    <Route path={`${match.path}/:roomTypeId`} component={EditRoomTypePage} />
    <Redirect to={match.path} />
  </Switch>
);
